import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { AuthContext } from "../context/AuthContext";

const About = () => {
  const { theme } = useTheme();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [btnHover, setBtnHover] = useState(false);

  const handleContactClick = () => {
    if (user) {
      navigate('/contact');
    } else {
      navigate('/login');
    }
  };
  const containerStyle = {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "8px",
    background: "var(--color-surface-1)",
    border: "1px solid rgba(255, 255, 255, 0.05)",
  };

  const socialBtnStyle = {
    display: "inline-block",
    margin: "10px",
    padding: "10px 20px",
    background: "var(--color-surface-2)",
    color: "var(--color-text-primary)",
    borderRadius: "8px",
    textDecoration: "none",
    transition: "all 0.3s ease",
    border: "1px solid rgba(255, 255, 255, 0.1)",
  };

  return (
    <div style={containerStyle}>
      <div style={{ textAlign: "center" }}>
        <img
          src={theme === 'light' ? '/RegardTraderLogo_black.png' : '/RegardTradersLogo.png'}
          alt="Regard Traders"
          style={{
            width: "180px",
            height: "180px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "4px solid #f97316",
            marginBottom: "20px",
            boxShadow: "0 4px 20px rgba(249, 115, 22, 0.4)",
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "10px",
              color: "var(--color-text-primary)",
            }}
          >
            About
          </h2>

          <h3
            style={{
              fontSize: "1.5rem",
              color: "#f97316",
              marginBottom: "15px",
            }}
          >
            REGARD TRADERS
          </h3>
        </div>

        <p
          style={{
            fontSize: "1.2rem",
            color: "#f97316",
            fontStyle: "italic",
            marginBottom: "30px",
          }}
        >
          "If it's hard to find, it's at Regard Traders."
        </p>
      </div>

      <div
        style={{
          textAlign: "left",
          color: "var(--color-text-secondary)",
          lineHeight: "1.9",
          fontSize: "1rem",
        }}
      >
        <h3
          style={{
            color: "var(--color-text-primary)",
            marginBottom: "15px",
            borderLeft: "4px solid #f97316",
            paddingLeft: "12px",
          }}
        >
          Our Story & Vision
        </h3>

        <h4
          style={{
            color: "#f97316",
            fontSize: "1.2rem",
            marginBottom: "15px",
            fontWeight: "600",
          }}
        >
          India’s Dedicated B2B Wholesale Marketplace
        </h4>

        <p style={{ marginBottom: "20px" }}>
          Namaste aur Regard Traders par aapka hardik swagat hai! Hum acchi tarah samajhte hain ki ek retail dukan chalana kitni mehnat ka kaam hai. Subah se raat tak counter sambhalna, grahakon ki pasand ka dhyan rakhna, aur sath hi har mahine dukan ke liye naya stock laane ki chinta karna. Naya aur trending stock lene ke liye aksar aapko Delhi, Surat ya Mumbai jaise bade commercial shehron ke chakkar kaatne padte hain. Dukan 3–4 din band rakhni padti hai, safar aur hotel ka hazaron rupaye ka kharcha alag se hota hai. Aur agar phone par alag-alag anjan vyapariyon se maal mangwayein, toh hamesha darr rehta hai ki paisa surakshit hai ya nahi, aur har jagah alag-alag transport ka jhanjhat alag. Isi pareshani ko hamesha ke liye aasan banane ke liye bana hai — Regard Traders.
        </p>

        <h3
          style={{
            color: "var(--color-text-primary)",
            marginTop: "35px",
            marginBottom: "15px",
            borderLeft: "4px solid #f97316",
            paddingLeft: "12px",
          }}
        >
          Hum Kaun Hain?
        </h3>
        <p style={{ marginBottom: "20px" }}>
          Regard Traders ek multi-vendor B2B wholesale marketplace hai. Hum koi aam chote stockist nahi hain. Humne India ke pramukh manufacturing aur wholesale hubs (jaise Delhi NCR, Surat, Mumbai, aur Ludhiana) ke verified manufacturers, direct factory owners aur primary importers ko ek digital platform par laya hai. Ab aapko 10 alag-alag shehron mein 10 alag logon ke piche bhagne ki bilkul zaroorat nahi hai. Desh bhar ke top manufacturing units ka fresh stock ab seedha aapke mobile par available hai.
        </p>

        <h3
          style={{
            color: "var(--color-text-primary)",
            marginTop: "35px",
            marginBottom: "20px",
            borderLeft: "4px solid #f97316",
            paddingLeft: "12px",
          }}
        >
          Hamari Pakki Guarantee: 3 Sahi Waade
        </h3>

        <div
          style={{
            background: "var(--color-surface-2)",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "15px",
          }}
        >
          <h4 style={{ color: "#f97316", marginBottom: "8px" }}>
            ✓ Sahi Stock (100% Quality Assurance)
          </h4>
          <p style={{ margin: 0 }}>
            Aap jo pasand karenge, wahi aapko milega. Dispatch se pehle har carton ki proper checking hoti hai taaki koi galat ya defective piece aapki dukan tak na pahuche.
          </p>
        </div>

        <div
          style={{
            background: "var(--color-surface-2)",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "15px",
          }}
        >
          <h4 style={{ color: "#f97316", marginBottom: "8px" }}>
            ✓ Sahi Price (Direct Factory Rates)
          </h4>
          <p style={{ margin: 0 }}>
            Bina kisi beech ke middlemen ya extra commission ke, aapko direct primary wholesale rates milte hain taaki aapka counter margin aur munafa hamesha sabse behtar rahe.
          </p>
        </div>

        <div
          style={{
            background: "var(--color-surface-2)",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "20px",
          }}
        >
          <h4 style={{ color: "#f97316", marginBottom: "8px" }}>
            ✓ Sahi Samay (Tracked & Safe Delivery)
          </h4>
          <p style={{ margin: 0 }}>
            Aapka samay anmol hai. Trusted commercial transport aur registered cargo partners ke zariye aapka maal sahi samay par, surakshit packing ke sath seedha aapki dukan tak pahunchana hamari zimmedari hai.
          </p>
        </div>

        <h3
          style={{
            color: "var(--color-text-primary)",
            marginTop: "35px",
            marginBottom: "20px",
            borderLeft: "4px solid #f97316",
            paddingLeft: "12px",
          }}
        >
          Regard Traders ke Sath Judne ke Fayde
        </h3>

        <div
          style={{
            background: "var(--color-surface-2)",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "15px",
          }}
        >
          <h4 style={{ color: "#f97316", marginBottom: "8px" }}>
            ✓ Sabhi Category Ek Hi Jagah
          </h4>
          <p style={{ margin: 0 }}>
            Fashion accessories, cosmetics, trendy jewellery, perfumes aur daily retail products—sab ek hi platform par dekhein aur asani se order karein.
          </p>
        </div>

        <div
          style={{
            background: "var(--color-surface-2)",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "15px",
          }}
        >
          <h4 style={{ color: "#f97316", marginBottom: "8px" }}>
            ✓ Ghar Baithe Business Karein
          </h4>
          <p style={{ margin: 0 }}>
            Na dukan band karne ka nuksaan, na safar ka fizool kharcha. 24/7 kabhi bhi apne counter se naya stock select karein.
          </p>
        </div>

        <div
          style={{
            background: "var(--color-surface-2)",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "20px",
          }}
        >
          <h4 style={{ color: "#f97316", marginBottom: "8px" }}>
            ✓ Pura Hisaab & Transparent Billing
          </h4>
          <p style={{ margin: 0 }}>
            GST invoice, transparent charges, aur dispatch hote hi WhatsApp par tracking details.
          </p>
        </div>

        <h3
          style={{
            color: "var(--color-text-primary)",
            marginTop: "35px",
            marginBottom: "15px",
            borderLeft: "4px solid #f97316",
            paddingLeft: "12px",
          }}
        >
          Hamara Lakshya (Our Vision)
        </h3>
        <p style={{ marginBottom: "20px" }}>
          Hamara sankalp hai ki chahe aapki dukan kisi bade shehar mein ho ya kisi chote kasbe ya gaon mein, aapko wahi direct factory wholesale rates, wahi naya stock aur wahi suvidha mile jo metro shehron ke bade vyapariyon ko milti hai. Aap poora dhyan dukan ki bikri badhane aur grahak jodne par lagaiye, supply, rate aur delivery ka bharosa Regard Traders par chodiye.
        </p>

        <h3
          style={{
            color: "var(--color-text-primary)",
            marginTop: "35px",
            marginBottom: "15px",
            borderLeft: "4px solid #f97316",
            paddingLeft: "12px",
          }}
        >
          Hamara Pata & Sampark
        </h3>
        <div
          style={{
            background: "var(--color-surface-2)",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "20px",
            lineHeight: "1.8",
          }}
        >
          <button
            onClick={handleContactClick}
            onMouseEnter={() => setBtnHover(true)}
            onMouseLeave={() => setBtnHover(false)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "11px 24px",
              background: btnHover
                ? "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)"
                : "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              fontSize: "0.95rem",
              cursor: "pointer",
              boxShadow: btnHover
                ? "0 6px 20px rgba(249, 115, 22, 0.45)"
                : "0 4px 12px rgba(249, 115, 22, 0.25)",
              transform: btnHover ? "translateY(-2px)" : "translateY(0)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "10px",
          marginTop: "40px",
        }}
      > */}
        {/* <a href="#" target="_blank" rel="noreferrer" style={socialBtnStyle}>
          🌐 Website
        </a> */}

        {/* <a
          href="#"
          target="_blank"
          rel="noreferrer"
          style={{
            ...socialBtnStyle,
            background: "rgba(239, 68, 68, 0.2)",
            borderColor: "#ef4444",
            color: "#ef4444",
          }}
        >
          📺 YouTube
        </a> */}

        {/* <a
          href="#"
          target="_blank"
          rel="noreferrer"
          style={{
            ...socialBtnStyle,
            background: "rgba(236, 72, 153, 0.2)",
            borderColor: "#ec4899",
            color: "#ec4899",
          }}
        >
          📸 Instagram
        </a> */}

        {/* <a
          href="#"
          target="_blank"
          rel="noreferrer"
          style={{
            ...socialBtnStyle,
            background: "rgba(59, 130, 246, 0.2)",
            borderColor: "#3b82f6",
            color: "#3b82f6",
          }}
        >
          💼 LinkedIn
        </a> */}

        {/* <a href="#" target="_blank" rel="noreferrer" style={socialBtnStyle}>
          ✖️ X (Twitter)
        </a> */}

        {/* <a
          href="https://wa.me/c/917222994585"
          target="_blank"
          rel="noreferrer"
          style={{
            ...socialBtnStyle,
            background: "rgba(16, 185, 129, 0.2)",
            borderColor: "#10b981",
            color: "#10b981",
          }}
        >
          💬 WhatsApp
        </a> */}

        {/* <a href="#" target="_blank" rel="noreferrer" style={socialBtnStyle}>
          🔗 Linktree
        </a> */}
      {/* </div> */}
    </div>
  );
};

export default About;